import { date, object } from 'yup';

export const FormSchema = object({
  date: date().required('Este campo es obligatorio'),
});
